module.exports = __webpack_public_path__ + "img/capacitor-angry.8231a55f.jpg";